import React from "react";
import { FiGlobe, FiSmartphone, FiCpu, FiLayers } from "react-icons/fi";
import { LuSettings, LuUsers, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuPalette, LuCode } from "react-icons/lu";
import {
  FaMagnifyingGlass,
  FaClipboardList,
  FaCode,
  FaBug,
  FaRocket,
} from "react-icons/fa6";
import {
  HiPencilSquare,
} from "react-icons/hi2";

// 1. Hero Block Configuration
export const AndroidHeroData = {
  backgroundImage: "/images/serviceBanners/AndroidDevelopments.webp",
  whiteImage: "/images/serviceBanners/AndroindBannerW.webp",
  subTitle: "ANDROID APP DEVELOPMENT",
  title: (
    <>
      Innovative <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Android App</span>
      <br /> Development
    </>
  ),
  description:
    "We build high-performance Android applications with modern technologies and scalable architecture. Our team creates feature-rich, user-friendly, and secure Android apps that deliver seamless performance across all Android devices.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance Android Apps",
      desc: "Fast and optimized Android app performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Android Design",
      desc: "Smooth experience across all Android devices.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure Android Applications",
      desc: "Built with secure and scalable architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Android Code",
      desc: "Optimized and maintainable code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

// 2. Stats Block
export const androidStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const androidSolutionsAndProcessData = {
  buildSubtitle: "OUR SERVICES",
  buildTitle: "Android App Solutions for Every Business Need",
  buildCards: [
    {
      title: "Custom Android Apps",
      desc: "High-performance Android apps for modern business needs.",
      icon: FiSmartphone,
      colorClass: "text-[#3DDC84]",
      bgClass: "bg-[#3DDC84]/10",
      borderClass: "border-[#3DDC84]/20 hover:border-[#3DDC84]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(61,220,132,0.25)]",
    },
    {
      title: "Enterprise Android Solutions",
      desc: "Secure and scalable apps for enterprise operations.",
      icon: FiCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Ecommerce Android Apps",
      desc: "Smooth and feature-rich mobile shopping experiences.",
      icon: FiGlobe,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Android Apps",
      desc: "Apps for booking, delivery, and service-based platforms.",
      icon: FiLayers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech Android Applications",
      desc: "Secure fintech apps with seamless user experience",
      icon: FiLayers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Custom Android Solutions",
      desc: "Tailored Android app development for unique business goals.",
      icon: FiLayers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
  ],
  processSubtitle: "OUR PROCESS",
  processTitle: "Our Proven Android App Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery",
      description: "We understand your Android app goals and business requirements.",
      icon: FaMagnifyingGlass,
    },
    {
      step: "02",
      title: "Planning",
      description: "We define app features, architecture, and development strategy.",
      icon: FaClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We create intuitive and user-friendly Android app interfaces.",
      icon: HiPencilSquare,
    },
    {
      step: "04",
      title: "Development",
      description: "We build scalable Android applications with optimized performance.",
      icon: FaCode,
    },
    {
      step: "05",
      title: "Testing",
      description: "We ensure secure, stable, and bug-free app functionality.",
      icon: FaBug,
    },
    {
      step: "06",
      title: "Deployment",
      description: "We launch Android apps with ongoing support and maintenance.",
      icon: FaRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE ANDROID APP DEVELOPMENT?",
  benefitsTitle: "Why Android App Development is the Right Choice",
  benefits: [
    " Custom Android app development",
    " Faster app deployment and updates",
    " Responsive and user-friendly UI",
    " Secure and scalable app architecture",
    " Optimized Android app performance",
    " Seamless API and feature integration",
    " Cost-effective mobile app solutions",
  ],

  logoImage: "/images/serviceBanners/AndroidDevelopments.webp",
  whiteLogoImage: "/images/serviceBanners/AndroindBannerW.webp",
};

// 4. Portfolio Data
export const androidPortfolioData = {
  subtitle: "OUR WORK",
  title: "Android Apps Making an Impact",
  buttonText: "View All Projects",
  buttonLink: "#",
  apps: [
    {
      title: "QuickCommerce",
      badge: "E-Commerce App",
      badgeColor: "bg-[#3DDC84]/10 text-[#3DDC84] border-[#3DDC84]/20",
      desc: "A fast-loading retail app optimized for diverse Android hardware levels.",
      downloads: "500k+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/Android-Development.png",
    },
    {
      title: "SafeVault",
      badge: "Security App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Enterprise-grade encryption tool for secure document sharing.",
      downloads: "100k+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/Enterprise-Android.png",
    },
  ],
};

// 5. Technologies Data
export const androidTechnologiesData = {
  techTitle: "OUR ANDROID STACK",
  technologies: [
    { name: "Java", icon: "Java" },
    { name: "Kotlin", icon: "Kotlin" },
    { name: "Firebase", icon: "Firebase" },
    { name: "SQLite", icon: "SQLite" },
    { name: "Rest API", icon: "RestAPI" },
    { name: "Material UI", icon: "MUI" },
  ],
  trustTitle: "TRUSTED NATIONWIDE",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const androidAboutData = [
  {
    title: "Scalable Android Applications for Digital Businesses",
    content: (
      <>
        Modern businesses require mobile applications that support accessibility, business growth, and long-term user engagement. A professional{" "}
        <b className="text-text-primary font-semibold">android app development company</b> helps organizations create scalable mobile solutions tailored to changing customer
        expectations and industry requirements. <b className="text-text-primary font-semibold">Tycho Technologies</b> delivers business-focused Android solutions that help brands
        improve digital accessibility and strengthen customer experiences across multiple industries.
      </>
    ),
  },
  {
    title: "Custom Android Solutions for Modern Industries",
    content: (
      <>
        Every business has unique operational goals, which makes <b className="text-text-primary font-semibold">custom android app development</b> important for creating
        personalized mobile experiences. From healthcare and ecommerce to logistics and fintech platforms, Android applications help businesses improve digital accessibility and
        customer interaction. Companies expanding their mobile ecosystem often collaborate with a trusted{" "}
        <a href="#" className="text-cyan-400 underline hover:text-cyan-300">
          ios app development company
        </a>{" "}
        to maintain consistent experiences across both Android and Apple platforms.
      </>
    ),
  },
  {
    title: "Advanced Mobile Development with Flexible Technologies",
    content: (
      <>
        The demand for innovative mobile platforms continues to grow across startups, enterprises, and service-based industries. Professional{" "}
        <b className="text-text-primary font-semibold">android application development services</b> help businesses create feature-focused applications aligned with modern user
        behavior and evolving market trends. Organizations also work with an experienced{" "}
        <a href="#" className="text-cyan-400 underline hover:text-cyan-300">
          hybrid app development company
        </a>{" "}
        to build flexible cross-platform applications that support faster scalability and broader device accessibility for modern digital audiences.
      </>
    ),
  },
  {
    title: "Reliable Android App Development Services in India",
    content: (
      <>
        Businesses looking to scale their digital presence often choose to <b className="text-text-primary font-semibold">hire android app developers</b> with expertise in modern
        frameworks, business-focused application strategy, and future-ready development practices. Partnering with a trusted{" "}
        <b className="text-text-primary font-semibold">android app development company in india</b> provides access to experienced mobile teams, scalable solutions, and long-term
        technical expertise. Companies also rely on professional <b className="text-text-primary font-semibold">android app development services india</b> providers to strengthen
        customer engagement and accelerate sustainable mobile growth.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const androidAppFaqs = [
  {
    q: "Why should I choose Android app development services in India?",
    a: "Android app development in India offers cost-effective, high-quality solutions with skilled developers experienced in building apps for various industries.",
  },
  {
    q: "What services does an Android app development company in India provide?",
    a: "An Android app development company in India offers end-to-end services including app design, development, testing, deployment, and post-launch support.",
  },
];
